import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Group, Panel, Separator } from "react-resizable-panels";
const meetingPanelStyle = `
  .meeting-panel-container > div {
    width: 100% !important;
    max-width: 100% !important;
  }
`;
/**
 * Shared HM Connect layout: 60/40 Teams + feedback, or full-bleed Teams when
 * the course flag hides the feedback form.
 */
const HmMeetingShell = ({ hideFeedbackForm, meeting, feedback, }) => {
    const meetingPanel = (_jsx("div", Object.assign({ className: "meeting-panel-container", style: {
            height: "100%",
            width: "100%",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        } }, { children: meeting })));
    return (_jsxs("div", Object.assign({ style: {
            overflow: "hidden",
            position: "relative",
            height: "calc(100vh - 64px)",
        } }, { children: [_jsx("style", { children: meetingPanelStyle }), hideFeedbackForm ? (meetingPanel) : (_jsxs(Group, Object.assign({ orientation: "horizontal", style: { height: "100%" } }, { children: [_jsx(Panel, Object.assign({ defaultSize: 60, minSize: 60, style: { overflow: "hidden" } }, { children: meetingPanel })), _jsx(Separator, { style: {
                            width: "4px",
                            backgroundColor: "#e0e0e0",
                            cursor: "col-resize",
                            transition: "background-color 0.2s",
                        } }), _jsx(Panel, Object.assign({ defaultSize: 40, minSize: 40, style: { overflow: "auto" } }, { children: _jsx("div", Object.assign({ style: { height: "100%", width: "100%", padding: "0px 10px" } }, { children: feedback })) }))] })))] })));
};
export default HmMeetingShell;
